var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e6-select-dynamic"},[_c('el-select',{attrs:{"clearable":"","filterable":"","loading":_vm.loading},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}},_vm._l((_vm.selectData),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }